import { jwtDecode } from 'jwt-decode';
import { EmployeeService } from 'services/EmployeeService';
const employeeService = new EmployeeService();

const gettingTags = async (setLoading, setTags) => {
    setLoading(true);

    await employeeService.employee
        .getTags()
        .then(async (response) => {
            const tags = jwtDecode(localStorage.getItem('access_token'))?.tags;

            if (JSON.parse(localStorage.getItem('permissions'))?.find((permission) => permission === 'employee.CreateTag')) {
                setTags(
                    response?.map((tag) => ({
                        id: tag.tag_id,
                        name: tag.tag_name,
                    })),
                );
            } else {
                setTags(
                    response
                        ?.map((tag) => ({
                            id: tag.tag_id,
                            name: tag.tag_name,
                        }))
                        .filter((tag) => tags.includes(tag.id)),
                );
            }
        })
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
};

const addingTag = async (setLoading, tag_name) => {
    setLoading(true);

    await employeeService.employee
        .createTag(tag_name)
        .then(async (response) => {})
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
};

const assigningEmployeeToTag = async (setLoading, employee_ids, tag_ids, start_date, end_date, closing, reloading, handlerAlert, t, overwrite = false) => {
    setLoading(true);
    await employeeService.employee
        .assignTagsToEmployee(employee_ids, tag_ids, start_date, end_date, overwrite)
        .then(async (response) => {
            closing();
            reloading();
            handlerAlert(true, {
                title: t('timekeeper.employees.dialog.assign_tag.messages.success.title'),
                message: t('timekeeper.employees.dialog.assign_tag.messages.success.message'),
                severity: 'success',
            });
        })
        .catch((error) => {
            console.error(error.message);
            handlerAlert(true, {
                title: t('timekeeper.employees.dialog.assign_tag.messages.error.title'),
                message: t('timekeeper.employees.dialog.assign_tag.messages.error.message'),
                severity: 'error',
            });
        })
        .finally(() => {
            setLoading(false);
        });
};

const addEmployee = async (setLoading, body, closing, reloading, handlerAlert, t) => {
    setLoading(true);

    await employeeService.employee
        .createEmployee(body)
        .then(async (response) => {
            closing();
            reloading();
            handlerAlert(true, {
                title: t('timekeeper.employees.dialog.add.messages.success.title'),
                message: t('timekeeper.employees.dialog.add.messages.success.message'),
                severity: 'success',
            });
        })
        .catch((error) => {
            console.error(error.message);

            handlerAlert(true, {
                title: t('timekeeper.employees.dialog.add.messages.error.title'),
                message: t('timekeeper.employees.dialog.add.messages.error.message'),
                severity: 'error',
            });
        })
        .finally(() => {
            setLoading(false);
        });
};

const EditEmployee = async (setLoading, employee_id, body, closing, reloading, handlerAlert, t) => {
    setLoading(true);

    await employeeService.employee
        .updateEmployee({ ...body, employee_id })
        .then((response) => {
            closing();
            reloading();
            handlerAlert(true, {
                title: t('timekeeper.employees.dialog.edit.messages.success.title'),
                message: t('timekeeper.employees.dialog.edit.messages.success.message'),
                severity: 'success',
            });
        })
        .catch((error) => {
            console.error(error.message);
            handlerAlert(true, {
                title: t('timekeeper.employees.dialog.edit.messages.error.title'),
                message: t('timekeeper.employees.dialog.edit.messages.error.message'),
                severity: 'error',
            });
        })
        .finally(() => {
            setLoading(false);
        });
};

const assingHiring = async (setLoading, body, closing, reloading, handlerAlert, t) => {
    setLoading(true);

    await employeeService.employee
        .assignHiringRange(body)
        .then((response) => {
            closing();
            reloading();
            handlerAlert(true, {
                title: t('timekeeper.employees.dialog.assign_contract.messages.success.title'),
                message: t('timekeeper.employees.dialog.assign_contract.messages.success.message'),
                severity: 'success',
            });
        })
        .catch((error) => {
            console.log(error.message);
            handlerAlert(true, {
                title: t('timekeeper.employees.dialog.assign_contract.messages.error.title'),
                message: t('timekeeper.employees.dialog.assign_contract.messages.error.message'),
                severity: 'error',
            });
        })
        .finally(() => {
            setLoading(false);
        });
};

const assingOrgpath = async (setLoading, body, closing, reloading, handlerAlert, t) => {
    setLoading(true);
    console.log('body', body);
    await employeeService.employee
        .assignHiringOrgpath(body)
        .then(() => {
            closing();
            reloading();
            handlerAlert(true, {
                title: t('timekeeper.employees.dialog.assign_contract.messages.success.title'),
                message: t('timekeeper.employees.dialog.assign_contract.messages.success.message'),
                severity: 'success',
            });
        })
        .catch((error) => {
            console.log(error.message);
            handlerAlert(true, {
                title: t('timekeeper.employees.dialog.assign_contract.messages.error.title'),
                message: t('timekeeper.employees.dialog.assign_contract.messages.error.message'),
                severity: 'error',
            });
        })
        .finally(() => {
            setLoading(false);
        });
};

const gettingHiring = async (setLoading, params, setContracts) => {
    setLoading(true);

    await employeeService.employee
        .getHiringRange(params)
        .then((response) => {
            console.log(`hiring range response`, response);
            setContracts(response);
        })
        .catch((error) => console.error(error.msg))
        .finally(() => setLoading(false));
};

const gettingSubcompanies = async (setLoading, setSubcompanies) => {
    setLoading(true);

    await employeeService.employee
        .getSubcompany()
        .then((response) => {
            console.log(`subcompanies response`, response);
            setSubcompanies(response);
        })
        .catch((error) => console.error('error', error.msg))
        .finally(() => setLoading(false));
};

const gettingAreas = async (setLoading, params, setAreas) => {
    setLoading(true);

    await employeeService.employee
        .getArea(params)
        .then((response) => {
            console.log(`areas response`, response);
            setAreas(response);
        })
        .catch((error) => console.error('error', error.msg))
        .finally(() => setLoading(false));
};

const gettingWorkPositions = async (setLoading, params, setWorkPositions) => {
    setLoading(true);

    await employeeService.employee
        .getWorkPosition(params)
        .then((response) => {
            console.log(`work positions response`, response);
            setWorkPositions(response);
        })
        .catch((error) => console.error('error', error.msg))
        .finally(() => setLoading(false));
};

const inactivatingEmployee = async (setLoading, hiring_range_id, body, closing, reloading, handlerAlert, t) => {
    setLoading(true);

    await employeeService.employee
        .terminateEmployee(hiring_range_id, body)
        .then((response) => {
            closing();
            reloading();
            handlerAlert(true, {
                title: t('timekeeper.employees.dialog.deactivate.messages.success.title'),
                message: t('timekeeper.employees.dialog.deactivate.messages.success.message'),
                severity: 'success',
            });
        })
        .catch((error) => {
            console.error(error.message);
            handlerAlert(true, {
                title: t('timekeeper.employees.dialog.deactivate.messages.error.title'),
                message: t('timekeeper.employees.dialog.deactivate.messages.error.message'),
                severity: 'error',
            });
        })
        .finally(() => {
            setLoading(false);
        });
};

const gettingDocumentTypeEmployee = async (setLoading, setDocumentTypes) => {
    setLoading(true);

    await employeeService.employee
        .getDocumentTypes()
        .then((response) => {
            setDocumentTypes(response);
        })
        .catch((error) => console.error('error', error.msg))
        .finally(() => setLoading(false));
};

export {
    gettingTags,
    addingTag,
    assigningEmployeeToTag,
    addEmployee,
    EditEmployee,
    assingHiring,
    assingOrgpath,
    gettingHiring,
    gettingSubcompanies,
    gettingAreas,
    gettingWorkPositions,
    inactivatingEmployee,
    gettingDocumentTypeEmployee,
};
